import { Injectable } from '@angular/core';

import { GetSubGraphResponse } from '@reach/interfaces/graph/graph.responses';

import { BaseApiService } from '~app-client/api/_internal';
import { WorkspaceId } from '~app-client/workspaces/types';
import {
	isPersistedWorkspaceId,
	trashedWorkspaceId,
	unassignedWorkspaceId,
} from '~app-client/workspaces/utils';

@Injectable({ providedIn: 'root' })
export class GraphApiService extends BaseApiService {
	protected commonPath = ['graph'];

	public async getGraph(ids: WorkspaceId[]): Promise<GetSubGraphResponse> {
		const workspaceIds = ids
			.filter((id) => isPersistedWorkspaceId(id))
			.filter((id) => ![unassignedWorkspaceId, trashedWorkspaceId].includes(id));
		const showUnassigned = ids.includes(unassignedWorkspaceId);
		const showTrash = ids.includes(trashedWorkspaceId);
		const body = {
			workspaceIds,
			includeUnassignedNodes: showUnassigned,
			includeTrashNodes: showTrash,
		};
		return await this.http.post<GetSubGraphResponse>(this.url('get-graph'), body);
	}
}
